// Farm fields carry no date of their own - only their GPS points are timestamped.
// The most recent point is therefore the best available "when was this field
// worked on" signal, and it is what the UI groups and sorts by.

export const UNDATED_LABEL = '—';

// Epoch ms of the newest GPS point, or 0 when the field has no usable timestamp.
// 0 sorts undated fields last and groups them under UNDATED_LABEL.
export const getFieldTimestamp = (field) => {
  if (!Array.isArray(field?.gpsPoints)) return 0;
  return field.gpsPoints.reduce((latest, point) => {
    const time = new Date(point?.timestamp).getTime();
    return Number.isNaN(time) ? latest : Math.max(latest, time);
  }, 0);
};

export const getFieldYear = (field) => {
  const time = getFieldTimestamp(field);
  return time ? new Date(time).getFullYear() : null;
};

// Buckets items into { year, label, items } groups, newest year first and
// undated items last. Within a group, items are newest first.
// getTimestamp maps an item to epoch ms - items here can be fields or, in
// MyFarm's case, the fieldData indexes that point at them.
export const groupByYear = (items, getTimestamp) => {
  const buckets = new Map();

  items.forEach((item) => {
    const time = getTimestamp(item) || 0;
    const year = time ? new Date(time).getFullYear() : null;
    if (!buckets.has(year)) buckets.set(year, []);
    buckets.get(year).push({ item, time });
  });

  return Array.from(buckets.entries())
    .map(([year, entries]) => ({
      year,
      label: year === null ? UNDATED_LABEL : String(year),
      items: entries.sort((a, b) => b.time - a.time).map((entry) => entry.item),
    }))
    .sort((a, b) => (b.year === null ? -Infinity : b.year) - (a.year === null ? -Infinity : a.year));
};
